var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 w-100"},[_c('ac-sql-builder-properties-editor'),_c('ac-sql-builder-navbar'),_c('ac-sql-builder-ui'),_c('ac-sql-builder-import-modal'),_c('ac-sql-builder-export-modal'),_c('ac-sql-builder-comment-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }